import React from "react";
import { Slot } from "expo-router";

export default function AppLayout(): React.JSX.Element {
  return <Slot />;
}
